var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('org-input',{attrs:{"main-id":_vm.mainId,"sub-id":_vm.subId,"name":_vm.orgName,"show-sub-org":""}})}
var staticRenderFns = []

export { render, staticRenderFns }